import { useState, useEffect } from 'react';
import { BrandLogo } from '../components/BrandLogo';
import { UserMenu } from '../components/UserMenu';
import { useMe } from '../features/auth/useMe';
import { Spinner } from '../components/Spinner';
import { CreateLinkForm } from '../features/create-link/CreateLinkForm';
import { LinksList } from '../features/links/LinksList';
import { ScopeToggle } from '../features/links/ScopeToggle';

type Scope = 'mine' | 'all';

function readScopeFromUrl(): Scope {
  return new URLSearchParams(window.location.search).get('scope') === 'all' ? 'all' : 'mine';
}

function writeScopeToUrl(s: Scope) {
  const url = new URL(window.location.href);
  if (s === 'all') url.searchParams.set('scope', 'all');
  else url.searchParams.delete('scope');
  window.history.replaceState({}, '', url.toString());
}

export function Dashboard() {
  const me = useMe();
  const [scope, setScope] = useState<Scope>(readScopeFromUrl);

  useEffect(() => {
    writeScopeToUrl(scope);
  }, [scope]);

  if (!me.data) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <Spinner size={24} />
      </main>
    );
  }

  const user = me.data;
  const showAllToggle = user.is_admin;
  const effectiveScope: Scope = showAllToggle ? scope : 'mine';
  const showOwner = effectiveScope === 'all' && user.is_admin;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 backdrop-blur bg-[color-mix(in_srgb,var(--color-page)_95%,transparent)] border-b border-[var(--color-border)]">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
          <BrandLogo />
          <UserMenu user={user} />
        </div>
      </header>
      <main className="max-w-3xl mx-auto w-full px-4 py-6 space-y-8">
        <section>
          <h2 className="font-display text-xl mb-3">Создать ссылку</h2>
          <CreateLinkForm />
        </section>
        <section>
          <div className="flex items-baseline justify-between mb-3">
            <h2 className="font-display text-xl">Ссылки</h2>
            {showAllToggle && <ScopeToggle value={scope} onChange={setScope} />}
          </div>
          <LinksList scope={effectiveScope} showOwner={showOwner} />
        </section>
      </main>
    </div>
  );
}
